import React, { lazy, Suspense, memo } from 'react'
import { useLoginModal } from '@/contexts/LoginModalContext'

// Lazy load header components
const DesktopHeader = lazy(() => import('./DesktopHeader'))
const MobileHeader = lazy(() => import('./MobileHeader'))
const NotificationPanel = lazy(() => import('./NotificationPanel'))

interface Props {
  featured_categories: any
  settings: any
  categories: any
}

// Skeleton loaders
// const HeaderSkeleton = () => (
//   <div className="animate-pulse">
//     <div className="h-12 bg-gray-200" />
//     <div className="h-16 bg-gray-100" />
//   </div>
// );

const NotificationSkeleton = () => (
  <div className="animate-pulse h-6 bg-yellow-100 py-[16px] px-1 min-w-full" />
);

const Header = memo(({
  featured_categories,
  settings,
  categories,
}: Props) => {
  const {
    isOpen,
    setIsOpen,
    setProductType,
    setCurrentView
  } = useLoginModal()
  
  const [lastOpened, setLastOpened] = React.useState<'register' | 'login'>('login')
  const [loginMethod, setLoginMethod] = React.useState<'email' | 'phone' | undefined>(undefined)

  return (
    <>
      <Suspense fallback={<NotificationSkeleton/>}>
        <NotificationPanel />
      </Suspense>
      <header className="header bg-white sticky top-0 z-[100] shadow-lg">
        <div className="container-fluid py-2 mx-auto">
          <Suspense>
            <MobileHeader
              setIsOpen={setIsOpen}
              setProductType={setProductType}
              setLastOpened={setLastOpened}
              headerCategories={categories}
              lastOpened={'login'}
              setCurrentView={setCurrentView}
            />
          </Suspense>
          <Suspense>
            <DesktopHeader
              featured_categories={featured_categories}
              setIsLoginOpen={setIsOpen}
              setIsRegisterOpen={setIsOpen}
              setIsForgotOpen={setIsOpen}
              setLastOpened={setLastOpened}
              lastOpened={lastOpened}
              setProductType={setProductType}
            />
          </Suspense>
        </div>
      </header>
    </>
  )
});

Header.displayName = 'Header';

export default Header;